<style>
  input.ng-invalid.ng-touched {
    border: 1px solid red;
  }

  .primaryEmail {
    border: 1px solid red;
  }

  .p-dropdown.ng-invalid.ng-touched:not(form)>div {
    border: 1px solid red;
  }
</style>
<section>
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-1"></div>
      <div class="col-sm-10 p-0">
        <div class="card">
          <div class="devcare-card-header">
            <span class="devcare-sub-header"><i class="fas fa-plus mr-1"></i>Vendor Registration</span>
                   <div class="row">      
                <div class="col-md-12">
                  <div class="">
                    <br>
                      <h5 class="text-dark text-sm"><i></i> Note:</h5>
                      <ul>
                        <li>Username must be a valid email address</li>
                        <li>Password must be 8-16 characters containing alphanumeric and symbols</li>               
                      </ul>              
                    </div>
                </div>
              </div> 
          </div>
          <div class="text-sm text-left">

          </div>
        </div>
      </div>
      <div class="col-sm-1"></div>
    </div>
  </div>
</section>
<!-- <section>
  <div class="row">
    <div class="col-md-1"></div>
    <div class="col-md-10">
      <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
        class="p-button-outlined p-button-danger float-right m-2 bg-primary"></button>
      <button pButton pRipple type="button" label="Save" icon="pi pi-check"
        [disabled]="!applicantAddForm.valid || applicantEmailAvail" (click)="onApplicantSubmit(applicantAddForm)"
        class="p-button-outlined p-button-success float-right m-2 bg-success"></button>
    </div>
    <div class="col-md-1"></div>
  </div>
</section> -->
<section>
  <form [formGroup]="preregisterForm" novalidate>
    <div class="row">
      <div class="col-md-1">
      </div>
      <div class="col-md-10">        
        <p-accordion>
          <p-accordionTab header="Company Profile" [selected]="true">
            <div class="row">
              <div class="col-lg-12">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-4">
                    <label for="firstname">Vendor Name<span class="required-field">*</span></label>
                    <input class="form-control" maxlength="100" type="text" pInputText>
                    <!-- <span class="text-danger"
                      *ngIf="(registerFormControl.firstName.touched) && registerFormControl.firstName.errors?.required">
                    </span> -->
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label for="middlename">Verify Vendor Name</label>
                    <input class="form-control" maxlength="100"  type="text" pInputText>
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label for="lastname">Vendor Short Name<span class="required-field">*</span></label>
                    <input class="form-control" maxlength="100"  type="text" pInputText>
                    <!-- <span class="text-danger"
                      *ngIf="(registerFormControl.lastName.touched) && registerFormControl.lastName.errors?.required">
                    </span> -->
                  </div>
                
                </div> 
                <div class="p-fluid p-formgrid p-grid">  
                  <div class="p-field p-col-12 p-md-4">
                      <label for="address">Email id<span class="required-field">*</span></label>
                      <input class="form-control" maxlength="100"  type="email" pInputText>
                    </div>                
                  <div class="p-field p-col-12 p-md-4">             
                    <label for="address">Address Line 1<span class="required-field">*</span></label>
                    <input class="form-control"   type="text" pInputText>
                    <!-- <span class="text-danger"
                      *ngIf="(registerFormControl.address.touched) && registerFormControl.address.errors?.required">
                    </span> -->
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label for="address">Address Line 2</label>
                    <input class="form-control" maxlength="100"  type="text" pInputText>
                  </div>                
                
                </div> 
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-4">
                    <label for="address">Web Address<span class="required-field">*</span></label>
                    <input type="text" class="form-control" pInputText>                  
                  </div>  
                  <div class="p-field p-col-12 p-md-4">
                    <label for="address">Tax ID Number<span class="required-field">*</span></label>
                    <input type="text" class="form-control" pInputText>                  
                  </div> 
                  <div class="p-field p-col-12 p-md-4">
                    <label for="selectedCountry">Country<span class="required-field">*</span></label>
                    <p-dropdown id="selectedCountry" optionLabel="name">
                    </p-dropdown>                
                  </div> 
                </div>
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-4">
                    <label for="address">State<span class="required-field">*</span></label>
                    <input type="text" class="form-control" pInputText>                  
                  </div>  
                  <div class="p-field p-col-12 p-md-4">
                    <label for="address">City<span class="required-field">*</span></label>
                    <input type="text" class="form-control" pInputText>                  
                  </div> 
                  <div class="p-field p-col-12 p-md-4">
                    <label for="address">Zip Code</label>
                    <input type="text" class="form-control" pInputText>                  
                  </div> 
                </div>                               
              </div>
            </div>
          </p-accordionTab>
        </p-accordion>
        <p-accordion>
          <p-accordionTab header="Company Details" [selected]="false" disabled="true">         

          </p-accordionTab>
        </p-accordion>
        <p-accordion>
          <p-accordionTab header="Delivery Team  Details" [selected]="false" disabled="true">
          
          </p-accordionTab>
        </p-accordion>
        <p-accordion>
          <p-accordionTab header="Reference" [selected]="false" disabled="true">
         
          </p-accordionTab>
        </p-accordion>
        <p-accordion>
          <p-accordionTab header="Admin Details" [selected]="false" disabled="true">
           
          </p-accordionTab>
        </p-accordion>
      </div>
      <div class="col-md-1">

      </div>
    </div>
  </form>
</section>
<section>
  <div class="row">
    <div class="col-md-1"></div>
    <div class="col-md-10">
      <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
        class="p-button-outlined p-button-sm p-button-danger float-right m-2 bg-primary"></button>
      <button pButton pRipple type="button" label="Register" icon="pi pi-check"         
        class="p-button-outlined p-button-sm p-button-success float-right m-2 bg-success"></button>
    </div>
    <div class="col-md-1"></div>
  </div>
</section>

<script>
  
</script>